import { HTMLAttributes } from 'react';
import { cn } from './cn';

export type BadgeProps = {
  variant?: 'neutral' | 'success' | 'danger' | 'warning' | 'primary';
} & HTMLAttributes<HTMLSpanElement>;

export function Badge({ variant = 'neutral', className, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-lg border px-2 py-0.5 text-xs font-medium',
        variant === 'neutral' && 'border-transparent bg-nova-muted text-nova-foreground',
        variant === 'success' && 'border-transparent bg-emerald-100 text-emerald-800',
        variant === 'danger' && 'border-transparent bg-red-100 text-red-700',
        variant === 'warning' && 'border-transparent bg-amber-100 text-amber-900',
        variant === 'primary' &&
          'border-transparent bg-nova-primary text-nova-primary-foreground',
        className
      )}
      {...props}
    />
  );
}
